<template>
	<div class="block __p __bg">
		<div class="wrapper">
			<header class="block_header">
				<div class="block_title">СТРИМЫ</div>
			</header>
			
			<div class="streams">
				<div class="streams_row">
					<div class="streams_col">
						<router-link to="/streams/1" class="streams_item">
							<div class="streams_image">
								<img src="/img/11.jpg" alt="">
								
								<div class="streams_online">В ЭФИРЕ</div>
								<div class="streams_cnt">5 зрителей</div>
							</div>
							<div class="streams_content">
								<div class="streams_ico">
									<img src="https://static-cdn.jtvnw.net/ttv-boxart/Dota%202-85x113.jpg" alt="">
								</div>
								<div class="streams_data">
									<div class="streams_title">УЛУЧШАЮ КОММУНИТИ 2800-3900 по фасту</div>
									<div class="streams_text">JustCooman</div>
								</div>
							</div>
						</router-link>
					</div>
					<div class="streams_col">
						<router-link to="/streams/2" class="streams_item">
							<div class="streams_image">
								<img src="/img/22.jpg" alt="">
								
								<div class="streams_online">В ЭФИРЕ</div>
								<div class="streams_cnt">5 зрителей</div>
							</div>
							<div class="streams_content">
								<div class="streams_ico">
									<img src="https://static-cdn.jtvnw.net/ttv-boxart/Doom%20Eternal-85x113.jpg" alt="">
								</div>
								<div class="streams_data">
									<div class="streams_title">[!title !prime] Doom Eternal - NIGHTMARE DIFFICULTY (Doom all day/night)</div>
									<div class="streams_text">JustCooman</div>
								</div>
							</div>
						</router-link>
					</div>
					<div class="streams_col">
						<router-link to="/streams/3" class="streams_item">
							<div class="streams_image">
								<img src="/img/33.jpg" alt="">
								
								<div class="streams_online">В ЭФИРЕ</div>
								<div class="streams_cnt">5 зрителей</div>
							</div>
							<div class="streams_content">
								<div class="streams_ico">
									<img src="https://static-cdn.jtvnw.net/ttv-boxart/Escape%20From%20Tarkov-85x113.jpg" alt="">
								</div>
								<div class="streams_data">
									<div class="streams_title">Гайд по РАЗВЯЗКЕ !развязка !дикие !звук !гайды !сборки</div>
									<div class="streams_text">JustCooman</div>
								</div>
							</div>
						</router-link>
					</div>
					<div class="streams_col">
						<router-link to="/streams/4" class="streams_item">
							<div class="streams_image">
								<img src="/img/44.jpg" alt="">
								
								<div class="streams_online">В ЭФИРЕ</div>
								<div class="streams_cnt">5 зрителей</div>
							</div>
							<div class="streams_content">
								<div class="streams_ico">
									<img src="https://static-cdn.jtvnw.net/ttv-boxart/Overwatch-85x113.jpg" alt="">
								</div>
								<div class="streams_data">
									<div class="streams_title">Что-то не так со шведами.</div>
									<div class="streams_text">JustCooman</div>
								</div>
							</div>
						</router-link>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {}
</script>

<style scoped>

</style>